import { FunctionComponent, useContext, useEffect, useRef } from "react";

// OpenLayers
import OlControl from "ol/control/Control";

// Custom components
import DisplayRouteClass from "./displayRouteClass";
import MapContext from "@/components/Map/MapContext";
import { findControl, getDefinedOptions, getEvents } from "@/lib/olHelpers";

// Types
import { MapContextType } from "@/@types/context/MapContext";
import type { IDisplayRouteControl } from "./DisplayRouteControl";

const DisplayRouteControlRoot: FunctionComponent<IDisplayRouteControl> = (props) => {
  const mapContext = useContext(MapContext) as MapContextType;

  const { id, target } = props;

  const elementRef = useRef(null);

  useEffect(() => {
    if (elementRef.current) {

      const options = {
        element: elementRef.current,
        target
      }

      const allOptions = {}
      Object.assign(allOptions, options, props);
      const definedOptions = getDefinedOptions(allOptions);

      const events = {};

      const control = new DisplayRouteClass(id, definedOptions);

      if (id) {
        control.set("id", id);
      }

      if (mapContext.map) {
        const mapControl = findControl(mapContext.map, id, DisplayRouteClass);
        if (mapControl) {
          mapContext.map.removeControl(mapControl);
        }
        mapContext.map.addControl(control as OlControl);
      } else {
        mapContext.initOptions.controls.push(control as OlControl);
      }

      const olEvents = getEvents(events, props);
      for (let eventName in olEvents) {
        // @ts-ignore TODO:  Argument of type 'string' is not assignable to parameter of type '("error" | "change" | "propertychange")[]'
        control.on(eventName, olEvents[eventName]);
      }

    }

    return () => {
      if (mapContext.map) {
        const mapControl = findControl(mapContext.map, id, DisplayRouteClass);
        if (mapControl) {
          mapContext.map.removeControl(mapControl);
        }
      }
    };
  }, []);

  return null;
};

export default DisplayRouteControlRoot;

